import { resetRouter } from '@/router'
import { login, logout, getIsComplete } from '@/api/user'
import { getUnreadList } from '@/api/messageCenter'
import router from '@/router'
import { BroadcastChannel } from 'broadcast-channel'
const NameKey = 'vue_admin_name'
const IsLoginKey = 'vue_admin_is_login'
const AuthorityKey = 'vue_admin_authority'
const UserInfo = 'user-info'
const NsResetPaw = 'is-reset-password'
const channel = new BroadcastChannel('logout-broadcast')
channel.onmessage = onChannelMessage
// channel.postMessage('I am not alone')

function onChannelMessage(messgae) {
  console.log('#########################################')
  console.log(messgae)
  console.log('#########################################')
  if (messgae === 'logout') {
    location.reload()
  } else if (messgae === 'login') {
    location = '/'
  }
}

const getDefaultState = () => {
  return {
    name: localStorage.getItem(NameKey),
    isLogin: localStorage.getItem(IsLoginKey),
    authority: localStorage.getItem(AuthorityKey),
    isResetPaw: localStorage.getItem(NsResetPaw) || '1',
    isComplete: '',
    completeData: {},
    userinfo: JSON.parse(localStorage.getItem(UserInfo)) || {},
    associationInfo: sessionStorage.getItem('association-info') ? JSON.parse(sessionStorage.getItem('association-info')) : {},
    messageList: [],
    userComplaintArea: ''

  }
}
const state = getDefaultState()
const mutations = {
  RESET_STATE: (state) => {
    localStorage.removeItem(NameKey)
    localStorage.removeItem(IsLoginKey)
    localStorage.removeItem(AuthorityKey)
    localStorage.removeItem(UserInfo)
    Object.assign(state, getDefaultState())
    channel.postMessage('logout')
  },
  SET_NAME: (state, name) => {
    state.name = name
    localStorage.setItem(NameKey, name)
  },
  SET_AUTHORITY: (state, authority) => {
    state.authority = authority
    localStorage.setItem(AuthorityKey, authority)
  },
  SET_ISLOGIN: (state, isLogin) => {
    state.isLogin = isLogin
    localStorage.setItem(IsLoginKey, isLogin)
  },
  SET_USERINO: (state, userinfo) => {
    state.userinfo = userinfo
    localStorage.setItem(UserInfo, JSON.stringify(userinfo))
    channel.postMessage('login')
  },
  SET_IS_COMPLETE: (state, isComplete) => {
    state.isComplete = isComplete
  },
  SET_COMPLETE_DATA: (state, completeData) => {
    state.completeData = completeData
  },
  SET_ISRESETPAW: (state, isResetPaw) => {
    state.isResetPaw = isResetPaw
    localStorage.setItem(NsResetPaw, isResetPaw)
  },
  SET_UNREADMSG: (state, unReadMsg) => {
    state.unReadMsg = unReadMsg
  },
  SET_ASSOCIATION: (state, associationInfo) => {
    state.associationInfo = associationInfo
    if (associationInfo) {
      sessionStorage.setItem('association-info', JSON.stringify(associationInfo))
    } else {
      sessionStorage.removeItem('association-info')
    }
  },
  SET_MESSAGE_LIST: (state, messageList) => {
    state.messageList = messageList
  }
}

const actions = {
  changeIsComplete({ commit }, isComplete) {
    commit('SET_IS_COMPLETE', isComplete)
  },
  changeIsResetPaw({ commit }, isResetPaw) {
    commit('SET_ISRESETPAW', isResetPaw)
  },
  changeCompleteData({ commit }, completeData) {
    commit('SET_COMPLETE_DATA', completeData)
  },
  getIsComplete({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      if (state.isComplete === '') {
        console.log(state.isComplete)
        getIsComplete().then(response => {
          commit('SET_IS_COMPLETE', response.isComplete)
          commit('SET_COMPLETE_DATA', response)
          resolve(response)
        }).catch(() => {
          dispatch('router/resetRouter', {}, { root: true })
          resolve({})
        })
      } else {
        resolve(state.completeData)
      }
    })
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password, verifyCode, uuid, targetUserId } = userInfo
    // 重新路由设定状态和路由
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), pword: password, verifyCode: verifyCode, uuid, platform: 'pcweb', targetUserId: targetUserId }).then(response => {
        console.log('store user->', response)
        commit('SET_ISLOGIN', true)
        commit('SET_NAME', response.trueName)
        commit('SET_USERINO', response)
        commit('SET_ISRESETPAW', response.isRestPwd + '')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        resetRouter()
        commit('RESET_STATE')
        commit('SET_IS_COMPLETE', '')
        dispatch('router/resetRouter', {}, { root: true })
        dispatch('router/setActiveMenu', '', { root: true })
        commit('SET_ISRESETPAW', '0')
        commit('SET_ASSOCIATION', null)
        commit('SET_MESSAGE_LIST', [])
        dispatch('app/setRole', '', { root: true })

        router.replace('/consultant_login')
      }).catch(error => {
        console.error(error)
      })
    })
  },
  setAssociation({ commit }, associationInfo) {
    commit('SET_ASSOCIATION', associationInfo)
  },
  setMessageList({ commit }, messageList) {
    commit('SET_MESSAGE_LIST', messageList)
  },
  getMessageList({ commit }) {
    // //////////////////   获取message
    return new Promise((resolve, reject) => {
      getUnreadList().then(res => {
        commit('SET_MESSAGE_LIST', res.list || [])
        resolve(res.list || [])
      }).catch(() => {
        resolve([])
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

